<template>
  <div class="privacy-policy">
    <h1 class="privacy-policy__title page-title">Privacy policy</h1>

    <div class="card" v-html="privacyPolicy.content"></div>
  </div>
</template>

<script>
import { getPrivacyPolicy } from '@/api/privacy.js';

export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      privacyPolicy: {
        content: '',
      },
    };
  },
  mounted() {
    this.fetchPrivacyPolicy();
  },
  methods: {
    async fetchPrivacyPolicy() {
      const { data, success } = await getPrivacyPolicy({ type: 1 });
      if (success) {
        this.privacyPolicy = data;
      }
    },
  },
};
</script>

<style lang="scss">
.privacy-policy {
  &__title {
    margin: 0;
    margin-bottom: var(--global-dimension-size-250);

    font-weight: 500;
    font-size: var(--font-size-800);
    line-height: 1.6;
  }
}
</style>
